import { render, staticRenderFns } from "./EditBanner.vue?vue&type=template&id=2a2cfd4a"
import script from "./EditBanner.vue?vue&type=script&lang=js"
export * from "./EditBanner.vue?vue&type=script&lang=js"
import style0 from "./EditBanner.vue?vue&type=style&index=0&id=2a2cfd4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports